import React from 'react';
import {
    Table,
    Row,
    Spin,
    Button, Popconfirm,
    Pagination,
} from 'antd';

import { asyncGet, actions, asyncGetUserList, asyncGetTaskInfo ,delect} from './reducers';
import { connect } from 'react-redux';
import SearchForm from './search.js';
import Edit from './edit.js';
import moment from 'moment';



class TaskNotes extends React.Component {
    constructor(props) {
        super(props);
    }
    componentDidMount() {
        this.props.asyncGet();
        this.props.asyncGetUserList();
    }

    changeHandle = (pagination, filters, sorter) => {
        this.props.changePagination(pagination);
        this.props.asyncGet();
    };
    /**
     * 分页器改变数据处理
     */
    handlePaginationChange = (current, pageSize) => {
        let pagination = {
            current,
            pageSize,
        };
        this.props.changePagination(pagination);
        this.props.asyncGet();
    };

    edit = (record, type) => {
        this.props.editShow();
        this.props.changeCurrentSelectId(record._id);
      //  this.props.asyncGetTaskInfo(record, type);
    }

    handleDelete = async record => {
        record.deleteFlag = '1';
        this.props.delect(record);
        this.props.asyncGet();
    }

    renderAction = (text, record) => {
        // console.log(expanded, record);
        return (
            <div>
                <Button type="primary" style={{ marginRight: '5px' }} size="small" onClick={() => {
                    this.edit(record);
                }}>
                    编辑
                </Button>
                <Popconfirm
                    title='确认删除'
                    okText='确定'
                    cancelText='取消'
                    onConfirm={() => {
                        this.handleDelete(record);
                    }}>
                    <Button type="danger" style={{ marginRight: '5px' }} size="small">
                        删除
                    </Button>
                </Popconfirm>
            </div>
        );
    };

    render() {
        let { list, uiStatus ,pagination} = this.props;
        let { isLoading } = uiStatus;
        const columns = [
            {
                title: 'eId',
                dataIndex: 'eId',
                key: 'eId',
            },
            {
                title: 'ps',
                dataIndex: 'ps',
                key: 'ps',
            },
            {
                title: 'taskType',
                dataIndex: 'taskType',
                key: 'taskType',
            },
            {
                title: '责任人',
                dataIndex: 'pricple',
                key: 'pricple',
            },
            {
                title: '时间',
                dataIndex: 'tm',
                key: 'tm',
            },
            {
              title: '备注',
              dataIndex: 'notes',
              key: 'notes',
            },
            {
                title: '操作',
                dataIndex: 'action',
                key: 'action',
                render: (text, record, index) => {
                    return this.renderAction(text, record, index);
                },
            }
        ];
        let { totalPage, current, pageSize } = pagination;
        return (
            <div style={{ marginBottom: '20px' }}>
                <Row style={{ marginTop: '10px', marginTop: '10px' }}>
                    <SearchForm {...this.props} />
                </Row>

                <Spin spinning={isLoading} tip="加载中...">
                    <Table
                        columns={columns}
                        dataSource={list}
                        pagination={false}
                    />
                     <Row type="flex" justify="end">
                        <Pagination
                            style={{ padding: '10px 10px' }}
                            size="small"
                            showQuickJumper
                            pageSize={pageSize}
                            current={current}
                            total={totalPage}
                            showTotal={(total, range) =>
                                `共 ${total ? total : '0'} 条记录，每页 ${pageSize} 条，这是第 ${totalPage
                                    ? current + '/' + totalPage
                                    : '1'} 页`}
                            showSizeChanger
                            pageSizeOptions={['10', '15', '20', '40']}
                            onShowSizeChange={this.handlePaginationChange}
                            onChange={this.handlePaginationChange}
                        />
                    </Row>
                    <Edit />
                </Spin>
            </div>
        );
    }
}

const mapStateToProps = state => ({
    list: state.taskNotes.list,
    pagination: state.taskNotes.pagination,
    proxyrepeatinfo: state.taskNotes.proxyrepeatinfo,
    uiStatus: state.taskNotes.uiStatus,
    agentsGroup: state.taskNotes.agentsGroup,
    transferData: state.taskNotes.transferData,
});
const mapDispatchToProps = dispatch => ({
    asyncGet: () => dispatch(asyncGet()),
    editShow: () => dispatch(actions.changeUiStatus({ isUpdateShow: true })),
    asyncGetTaskInfo: (record, type) => dispatch(asyncGetTaskInfo(record, type)),
    asyncGetUserList: () => dispatch(asyncGetUserList()),
    changePagination: data => dispatch(actions.changePagination(data)),
    changeCurrentSelectId: id => dispatch(actions.changeCurrentSelectId(id)),
    delect: record => dispatch(delect(record)),
});
export default connect(mapStateToProps, mapDispatchToProps)(TaskNotes);






// WEBPACK FOOTER //
// ./pages/sign/taskNotes/index.js